export const firebaseConfig = {
  apiKey: "AIzaSyD2VJl5JC5Mr_vKWtrbO0e3riGhJ9EQBMc",
  authDomain: "flipper-3c9c3.firebaseapp.com",
  databaseURL: "https://flipper-3c9c3.firebaseio.com",
  projectId: "flipper-3c9c3",
  storageBucket: "flipper-3c9c3.appspot.com",
  messagingSenderId: "743457743798",
  appId: "1:743457743798:web:9d11451795a9ca2c871717",
  measurementId: "G-9JVHRV63QM",
};
